<script lang="ts">
	import { onMount, onDestroy, untrack } from 'svelte';

	interface Props {
		threshold?: number;
		horizontal?: boolean;
		elementScroll?: HTMLElement | null;
		hasMore?: boolean;
		reverse?: boolean;
		window?: boolean;
		onloadmore: () => void;
	}

	let {
		threshold = 0,
		horizontal = false,
		elementScroll = null,
		hasMore = true,
		reverse = false,
		window = false,
		onloadmore
	}: Props = $props();

	let isLoadMore = $state(false);
	let component = $state<HTMLDivElement | undefined>();
	let beforeScrollHeight = $state<number | undefined>();
	let beforeScrollTop = $state<number | undefined>();
	let element = $state<HTMLElement>();

	$effect(() => {
		if (element) {
			if (reverse) {
				element.scrollTop = element.scrollHeight;
			}
			element.addEventListener(
				'scroll',
				onScroll as Parameters<typeof element.addEventListener>[1]
			);
			element.addEventListener(
				'resize',
				onScroll as Parameters<typeof element.addEventListener>[1]
			);
		}
	});

	$effect(() => {
		if (
			isLoadMore &&
			reverse &&
			element &&
			beforeScrollHeight !== undefined &&
			beforeScrollTop !== undefined
		) {
			element.scrollTop = element.scrollHeight - beforeScrollHeight + beforeScrollTop;
		}
	});

	const onScroll = (e: Event & { target?: HTMLElement }) => {
		if (!hasMore) return;
		const target = e.target;
		const offset = calcOffset(target, reverse, horizontal);
		untrack(() => {
			if (offset <= threshold) {
				if (!isLoadMore && hasMore) {
					onloadmore();
					beforeScrollHeight = target.scrollHeight;
					beforeScrollTop = target.scrollTop;
				}
				isLoadMore = true;
			} else {
				isLoadMore = false;
			}
		});
	};
	const calcOffset = (
		target: HTMLElement & { documentElement?: HTMLElement },
		reverse: boolean,
		horizontal: boolean
	) => {
		const element = target.documentElement ? target.documentElement : (target as HTMLElement);
		if (reverse) {
			return horizontal ? element.scrollLeft : element.scrollTop;
		}
		return horizontal
			? element.scrollWidth - element.clientWidth - element.scrollLeft
			: element.scrollHeight - element.clientHeight - element.scrollTop;
	};
	onMount(() => {
		if (window) {
			element = document as unknown as HTMLElement;
		} else if (elementScroll) {
			element = elementScroll;
		} else {
			element = component?.parentNode as unknown as HTMLElement;
		}
	});
	onDestroy(() => {
		if (element) {
			element.removeEventListener(
				'scroll',
				onScroll as Parameters<typeof element.addEventListener>[1]
			);
			element.removeEventListener(
				'resize',
				onScroll as Parameters<typeof element.addEventListener>[1]
			);
		}
	});
</script>

{#if !window && !elementScroll}
	<div bind:this={component} id="svelte-infinite-scroll" style="width: 0;"></div>
{/if}
